
import BasePropertyView from 'BasePropertyView';
import util from 'util/Util.js';
import contentTemplate from 'properties/style/scrollbars.ejs';

class StyleScrollbarsView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);
        
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]' : 'updateAttributes'
        }
        // Add needed property
        if (!this.model.get('horizontalScroll')) {
            this.model.set('horizontalScroll', 'false', {silent:true});
        }
        if (!this.model.get('verticalScroll')) {
            this.model.set('verticalScroll', (this.model.get('verticalScroll') === ''), {silent:true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        this.model.set( propName, propVal );
    }

    render() {
        super.render();

        this.$el.html(this.template(this.model.toJSON()));

        let bHorScroll = util.isTrue(this.model.get('horizontalScroll'));
        $(`input[name='horizontalScroll']`).prop('checked', bHorScroll );

        let bVerScroll = util.isTrue(this.model.get('verticalScroll'));
        $(`input[name='verticalScroll']`).prop('checked', bVerScroll );

        this.delegateEvents();

        return this;
    }

    

}

export default StyleScrollbarsView;